export const APP_STORE_URL =
  'https://apps.apple.com/app/apple-store/id6450863808';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.albernackee.blur';

export type Platform = 'ios' | 'android' | 'unknown';

export function detectPlatform(): Platform {
  const userAgent = navigator.userAgent || navigator.vendor || '';

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return 'ios';
  }

  return 'unknown';
}

export function getBestDownloadUrl(campaignTag?: string): string | null {
  const platform = detectPlatform();

  if (platform === 'ios') {
    if (campaignTag) {
      return `${APP_STORE_URL}?pt=80648800&ct=${campaignTag}&mt=8`;
    }
    return APP_STORE_URL;
  }

  if (platform === 'android') {
    if (campaignTag) {
      return `${PLAY_STORE_URL}&utm_source=web&utm_campaign=${campaignTag}`;
    }
    return PLAY_STORE_URL;
  }

  return null;
}
